import {
  GridRenderEditCellParams,
  GridRowId,
  useGridApiContext,
} from '@mui/x-data-grid';
import ServicesLookup from '.';

export type ServicesLookupEditCellProps = GridRenderEditCellParams & {
  entityId: string;
  onChange: (value: any) => void;
  onCreateNew: (id: GridRowId) => void;
  placeholder?: string;
};
export const ServicesLookupEditCell = (props: ServicesLookupEditCellProps) => {
  const { id, field, entityId, placeholder } = props;
  const apiRef = useGridApiContext();

  const onChange = (value: any) => {
    apiRef.current.setEditCellValue({
      id,
      field,
      value: value?.description,
    });
    props.onChange(value);
    apiRef.current.stopCellEditMode({ id, field });
  };
  return (
    <ServicesLookup
      entityId={entityId}
      value={props.value}
      onChange={onChange}
      placeholder={placeholder}
      onCreateNew={() => {
        props.onCreateNew(id);
      }}
    />
  );
};
